module.exports = __webpack_public_path__ + "img/samandehi.5bc898d4.png";